import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { GetPerek } from '../Util/Prakim';
import HeaderPerek from '../Components/HeaderPerek';
import IconBack from "../Icons/IconBack";
import { useFontPinch } from '../Util/useFontPinch';

const Perek = (props) => {
  const ref = useRef()
  const params = useParams();
  const navigate = useNavigate();

  const [statePerekData, setStatePerekData] = useState(null);
  const stateFontSize = useFontPinch(ref);

  useEffect(() => {
    GetPerek(params.type, params.id).then(
      (myResolve) => {
        setStatePerekData(myResolve);
      },
      (myReject) => {
        setStatePerekData(myReject);
      }
    );
  }, [params.id]);


  if (!statePerekData)
    return <h4>טוען נתונים...</h4>

  return (
    <div className="shiur-main">
      <HeaderPerek type={ params.type } id={ params.id } />
      <div className="shiur-main shiur-content" ref={ref} style={ { fontSize: `${ stateFontSize }px`, touchAction: 'pan-y' } }>{ statePerekData }</div>
      <a className="menu-float-icon" onClick={ () => { navigate(`/pr/${params.type}`); window.scrollTo(0,0); }}><IconBack /></a>
    </div>
  );
}

export default Perek;
